// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Evn","importantInfo":"styles_importantInfo__3201s"};